export enum RepairabilityFlagEnum {
  PRODUCT_FOUND = 'PRODUCT_FOUND',
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND'
}
